import Payment from '@/models/Payment'

export default function (value) {
  const channelOption = Payment.channelOptions.find(
    channelOption => channelOption.value === value
  )

  return channelOption != null ? channelOption.name : value
}
